import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { Employee } from '@synergy/models';

import { DeleteEmployeeRequest } from './delete-employee-request';
import { GetEmployeeRequest } from './get-employee-request';
import { UpdateEmployeeRequest } from './update-employee-request';

export class CustomerEmployeeApi {
    constructor(protected baseUrl: string) {}

    public getEmployees(customerId: number): Promise<ApiResult<GetEmployeeRequest>> {
        return safeRequest(
            () =>
                request.get<GetEmployeeRequest>(`${this.baseUrl}/customers/${customerId}/employees`, {
                    params: new URLSearchParams({ limit: '10000' }),
                }),
            response => response.data
        );
    }

    public AddEmployee(customerId: number, contactId: number, positionId?: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/customers/${customerId}/employees/${contactId}`, { positionId }),
            () => null
        );
    }

    public updateEmployee(
        customerId: number,
        contactId: number,
        updateRequest: UpdateEmployeeRequest
    ): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/customers/${customerId}/employees/${contactId}`, updateRequest),
            () => null
        );
    }

    public deleteEmployee(
        customerId: number,
        employeeId: number,
        deleteRequest: DeleteEmployeeRequest
    ): Promise<ApiResult<null>> {
        return safeRequest(
            () =>
                request.delete(`${this.baseUrl}/customers/${customerId}/employees/${employeeId}`, {
                    data: deleteRequest,
                }),
            () => null
        );
    }

    public searchEmployees(customerId: number, search?: string): Promise<ApiResult<Employee[]>> {
        const params = new URLSearchParams();
        if (search) {
            params.set('search', search);
        }
        return safeRequest(
            () =>
                request.get<PaginatedResponse<Employee>>(`${this.baseUrl}/customers/${customerId}/employees/search`, {
                    params,
                }),
            response => response.data.items
        );
    }
}
